import React from 'react';
import { useDispatch } from 'react-redux';
import shortid from 'shortid';
import { addFoodGroup } from 'actions/index';

function PanelAddFoodGroup({ onFoodGroupAdded }) {
    const dispatch = useDispatch();

    const addToRecipe = (foodGroupType) => {
        dispatch(addFoodGroup({ id: shortid(), title: '', description: '', type: foodGroupType, opened: true }));
        onFoodGroupAdded();
    };

    return (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            <div className="flex flex-col flex-1">
                <div className="flex flex-col flex-1">
                    <div className="p-[1em]">
                        <p><a onClick={() => addToRecipe('plate')}>Přidat talíř</a></p>
                        <p><a onClick={() => addToRecipe('bowl')}>Přidat misku</a></p>
                        <p><a onClick={() => addToRecipe('cup')}>Přidat šálek</a></p>
                        <p><a onClick={() => addToRecipe('glass')}>Přidat sklenici</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PanelAddFoodGroup;
